/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateLocationDto = {
  /**
   * Location name
   */
  name: string;
  /**
   * Location type
   */
  type: CreateLocationDto.type;
  /**
   * Location address
   */
  address: string;
  /**
   * Location status
   */
  status: CreateLocationDto.status;
};
export namespace CreateLocationDto {
  /**
   * Location type
   */
  export enum type {
    WAREHOUSE = 'WAREHOUSE',
    BRANCH = 'BRANCH',
  }
  /**
   * Location status
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
  }
}
